import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { NeighborhoodDetailsFragment } from '@api/fragments'
import { INeighborhoodDetails } from '@api'

interface Payload {
  data: {
    node: INeighborhoodDetails
  }
}

export const neighborhoodDetailsQuery = gql`
  query Neighborhood($id: ID!) {
    node(id: $id) {
      ... on Neighborhood {
        ...NeighborhoodDetailsFragment
      }
    }
  }
  ${NeighborhoodDetailsFragment}
`

export default function details(neighborhoodId: string): Promise<INeighborhoodDetails> {
  return client.gql
    .query({
      query: neighborhoodDetailsQuery,
      variables: { id: neighborhoodId },
    })
    .then(({ data: { node } }: Payload) => node)
}
